module.exports = __webpack_public_path__ + "media/images/clarinet_supplies-00b3facdf607482bafe211cb27a9aafa.jpg";